import { KiteIcon } from '@kite/react-kite';
import React from 'react';
import { QuizCardInputs } from './QuizCardsInput';
export const QuizCard1 = (props: QuizCardInputs) => {
    const onChange = (evt) => {
        const me = props.config[props.idx];
        me.value = {
            [evt.target.name]: evt.target.value,
        };
        me.valid = true;
        props.setConfig([...props.config]);
    };
    const { answers } = props.config[props.idx];
    return (
        <>
            {answers.map((answer) => {
                const answerType = Object.keys(answer)[0];
                const answerValue = answer[answerType];
                const inputValue =
                    answerType === `small` ? `Small Brand` : `Large Brand`;
                return (
                    <div className="radio" key={answerType}>
                        <input
                            className="kite-button--md"
                            type="radio"
                            id={answerType}
                            name="brand"
                            value={inputValue}
                            onChange={onChange}
                            disabled={!props.viewable}
                        />
                        <label htmlFor={answerType}>
                            <KiteIcon icon="ki-checkmark" className="check" />
                            {answerValue}
                        </label>
                    </div>
                );
            })}
        </>
    );
};
